var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceEpisodesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 13.5,
    fill: "#E7E0F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 7,
    r: 7,
    fill: "#E7E0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30.6666L12.5 26.6666H7.16667C6.43333 26.6666 5.80556 26.4055 5.28333 25.8833C4.76111 25.3611 4.5 24.7333 4.5 24V5.33329C4.5 4.59996 4.76111 3.97218 5.28333 3.44996C5.80556 2.92774 6.43333 2.66663 7.16667 2.66663H25.8333C26.5667 2.66663 27.1944 2.92774 27.7167 3.44996C28.2389 3.97218 28.5 4.59996 28.5 5.33329V24C28.5 24.7333 28.2389 25.3611 27.7167 25.8833C27.1944 26.4055 26.5667 26.6666 25.8333 26.6666H20.5L16.5 30.6666ZM7.16667 22.4666C8.36667 21.2888 9.76111 20.3611 11.35 19.6833C12.9389 19.0055 14.6556 18.6666 16.5 18.6666C18.3444 18.6666 20.0611 19.0055 21.65 19.6833C23.2389 20.3611 24.6333 21.2888 25.8333 22.4666V5.33329H7.16667V22.4666ZM16.5 16C17.7889 16 18.8889 15.5444 19.8 14.6333C20.7111 13.7222 21.1667 12.6222 21.1667 11.3333C21.1667 10.0444 20.7111 8.9444 19.8 8.03329C18.8889 7.12218 17.7889 6.66663 16.5 6.66663C15.2111 6.66663 14.1111 7.12218 13.2 8.03329C12.2889 8.9444 11.8333 10.0444 11.8333 11.3333C11.8333 12.6222 12.2889 13.7222 13.2 14.6333C14.1111 15.5444 15.2111 16 16.5 16ZM9.83333 24H23.1667V23.6666C22.2333 22.8888 21.2 22.3055 20.0667 21.9166C18.9333 21.5277 17.7444 21.3333 16.5 21.3333C15.2556 21.3333 14.0667 21.5277 12.9333 21.9166C11.8 22.3055 10.7667 22.8888 9.83333 23.6666V24ZM16.5 13.3333C15.9444 13.3333 15.4722 13.1388 15.0833 12.75C14.6944 12.3611 14.5 11.8888 14.5 11.3333C14.5 10.7777 14.6944 10.3055 15.0833 9.91663C15.4722 9.52774 15.9444 9.33329 16.5 9.33329C17.0556 9.33329 17.5278 9.52774 17.9167 9.91663C18.3056 10.3055 18.5 10.7777 18.5 11.3333C18.5 11.8888 18.3056 12.3611 17.9167 12.75C17.5278 13.1388 17.0556 13.3333 16.5 13.3333Z",
    fill: "#873CAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceEpisodesIcon);
export default __webpack_public_path__ + "static/media/service_episodes_icon.985f7e51b74dc792fee3e2362fb6c002.svg";
export { ForwardRef as ReactComponent };